import { configs } from 'configuration';
import { KoAPI } from "packages";
const version = configs().API_VERSION;
export const WorkspaceFilesAPI = {
  getFolders(query, workspaceId) {
    return KoAPI.get(`/api/${version}/file/project/folder`, {
      query: { ...query }, header: {
        "workspace": workspaceId
      }
    });
  },
  getFolderById(id) {
    return KoAPI.get(`/api/${version}/file/folder/${id}`);
  },
  linkToWorkspace(id, data) {
    return KoAPI.update(`/api/${version}/file/update/project/${id}`, { data });
  },
  getDocuments(query, folderId, workspaceId) {
    if (folderId) {
      query.folderId = folderId;
    }
    return KoAPI.get(`/api/${version}/file/project/files`, {
      query: { ...query }, header: {
        "workspace": workspaceId
      }
    });

  }
};